import { Directive, ElementRef, Input } from '@angular/core';
import { focusable } from '../utils/focusable';

@Directive({ selector: '[skl-focus-on-init]' })
export class FocusOnInitDirective {
    @Input('skl-focus-on-init') public options: {type: 'self' | 'input', condition: boolean} | undefined = {type: 'input', condition: true};

    public constructor(
        private readonly elementRef: ElementRef
    ) { }

    public ngAfterViewInit(): void {
        if (!this.options) return;

        if (!this.options.condition) return;

        if (this.options.type === 'self') {
            this.elementRef.nativeElement.focus();

        } else if (this.options.type === 'input') {
            const props = focusable(this.elementRef.nativeElement);
            (props.element as any)[props.focusMethodName]();
        }
    }
}
